var map = {
	"./list/index": 559,
	"./list/index.vue": 559
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1725;


//////////////////
// WEBPACK FOOTER
// ./src/components/page/messages ^\.\/.*$
// module id = 1725
// module chunks = 7